import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";

const API = "https://api.ctexpresskh.com/api";
const LANGS = [
  { code: "en", label: "GB Edit English" },
  { code: "kh", label: "KH Edit Khmer" },
  { code: "cn", label: "CN Edit Chinese" },
];

export default function Languages() {
  const [activeLang, setActiveLang] = useState("en");
  const [editing, setEditing] = useState({});
  const [enKeys, setEnKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("token");

  useEffect(() => { load(); }, []);

  const load = async () => {
    setLoading(true);
    try {
      const res = await fetch(API + "/translations", { headers: { Authorization: "Bearer " + token } });
      const data = await res.json();
      const grouped = {};
      (data.data || []).forEach(r => {
        if (!grouped[r.lang]) grouped[r.lang] = {};
        grouped[r.lang][r.key] = r.value;
      });
      setEditing(grouped);
      setEnKeys(Object.keys(grouped["en"] || {}));
    } catch {}
    setLoading(false);
  };

  const save = async (lang, key, value) => {
    try {
      const res = await fetch(API + "/translations/" + lang + "/" + key, {
        method: "PUT",
        headers: { "Content-Type": "application/json", Authorization: "Bearer " + token },
        body: JSON.stringify({ value })
      });
      const data = await res.json();
      if (data.success) toast.success("Saved!");
      else toast.error(data.message);
    } catch { toast.error("Error"); }
  };

  const currentLang = editing[activeLang] || {};

  return (
    <div style={{ padding: 32 }}>
      <div style={{ marginBottom: 24 }}>
        <h1 style={{ margin: 0, fontSize: 24, color: "#1e293b" }}>Language & Translations</h1>
        <p style={{ margin: "4px 0 0", color: "#64748b", fontSize: 14 }}>Edit translations for each language. Changes are saved automatically on blur.</p>
      </div>
      <div style={{ display: "flex", gap: 12, marginBottom: 24 }}>
        {LANGS.map(l => (
          <button key={l.code} onClick={() => setActiveLang(l.code)}
            style={{ padding: "10px 24px", borderRadius: 8, border: "2px solid", cursor: "pointer", fontWeight: 700, fontSize: 14,
              borderColor: activeLang === l.code ? "#f97316" : "#e2e8f0",
              background: activeLang === l.code ? "#fff7ed" : "#fff",
              color: activeLang === l.code ? "#f97316" : "#64748b" }}>
            {l.label}
          </button>
        ))}
      </div>
      <div style={{ background: "#fff", borderRadius: 12, boxShadow: "0 1px 4px rgba(0,0,0,0.08)", overflow: "hidden" }}>
        <div style={{ padding: "12px 20px", background: "#f8fafc", borderBottom: "1px solid #e2e8f0", display: "flex", justifyContent: "space-between" }}>
          <span style={{ fontWeight: 700, color: "#1e293b" }}>{LANGS.find(l => l.code === activeLang)?.label}</span>
          <span style={{ fontSize: 13, color: "#64748b" }}>{enKeys.length} phrases</span>
        </div>
        {loading ? <div style={{ padding: 40, textAlign: "center", color: "#94a3b8" }}>Loading...</div>
          : enKeys.map(key => (
          <div key={key} style={{ display: "flex", alignItems: "center", padding: "10px 20px", borderBottom: "1px solid #f8fafc", gap: 16 }}>
            <div style={{ width: 220, flexShrink: 0 }}>
              <div style={{ fontSize: 12, fontWeight: 700, color: "#f97316", fontFamily: "monospace" }}>{key}</div>
              <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 2 }}>{(editing["en"] || {})[key] || ""}</div>
            </div>
            <input value={currentLang[key] || ""}
              onChange={e => { const n = { ...editing }; if (!n[activeLang]) n[activeLang] = {}; n[activeLang][key] = e.target.value; setEditing(n); }}
              onBlur={e => save(activeLang, key, e.target.value)}
              style={{ flex: 1, padding: "8px 12px", border: "1px solid #e2e8f0", borderRadius: 8, fontSize: 14, outline: "none" }}
              onFocus={e => e.target.style.borderColor = "#f97316"}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
